import React from 'react'

const StocksType = React.lazy(() => import('pages/StocksType/StocksType'));

const StocksTypeRoutes = [
    {
        path: '/stocks-type',
        exact: true,
        name: 'Danh sách loại kho',
        function: 'ST_STOCKSINTYPE_VIEW',
        component: StocksType,
    },
]

export default StocksTypeRoutes
